export const storageName = 'adwise-vat-display';

const getVatDisplayFromSearchParam = () => {
  return new URLSearchParams(window.location.search).get('vat-display');
};

export const includingVat = () => {
  /**
   * Use <body> classes to determine if VAT is included or excluded.
   * Adwise was asked to not change these classes.
   */

  if (document.body.classList.contains('vat-display-including')) {
    return true;
  }

  if (document.body.classList.contains('vat-display-excluding')) {
    return false;
  }

  return true;
};

export default function vatToggle(store) {
  const vatDisplaySearchParam = getVatDisplayFromSearchParam();

  const update = (value) => {
    store.commit('data/setIncludingVat', value);
  };

  if (vatDisplaySearchParam !== null) {
    update(vatDisplaySearchParam === 'including');
  } else {
    update(includingVat());
  }

  new MutationObserver(() => {
    update(includingVat());
  }).observe(document.body, { attributes: true });
}
